<template>
  <v-card>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col>
            <template>
              <v-tabs
                v-model="selectedTab"
                fixed-tabs
                centered
                color="#0dc4b8"
                slider-color="#0dc4b8"
              >
                <v-tab>Cliente</v-tab>
                <v-tab>Financeiro</v-tab>
                <v-tab>Endereço</v-tab>
                <v-tab>Telefones</v-tab>
                <v-tab>Conta</v-tab>
                <v-tab>Nível</v-tab>
              </v-tabs>
            </template>
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="#0dc4b8"
            ></v-progress-linear>
          </v-col>
        </v-row>

        <v-row v-if="!isLoading">
          <v-col>
            <v-tabs-items v-model="selectedTab">
              <v-tab-item>
                <Client :selectedItem="selectedItem.client" />
              </v-tab-item>
              <v-tab-item>
                <Income :selectedItem="selectedItem.client.income" />
              </v-tab-item>
              <v-tab-item>
                <Address :selectedItem="selectedItem.address" />
              </v-tab-item>
              <v-tab-item>
                <Phones :selectedItem="selectedItem.phones" />
              </v-tab-item>
              <v-tab-item>
                <User :selectedItem="selectedItem" />
              </v-tab-item>
              <v-tab-item>
                <Level :selectedItem="selectedItem" />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
      color="#0dc4b8" 
      text
      @click="$emit('onClose');"
      >
        Fechar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
import { mapMutations } from 'vuex';
import ClientsService from '../../services/clients.service';
import Address from './_address.vue';
import Client from './_client.vue';
import Income from './_income.vue';
import Phones from './_phones.vue';
import User from './_user.vue';
import Level from './_level.vue';

export default {
  name: 'ClientsForm',
  components: {
    Address,
    Client,
    Income,
    Phones,
    User,
    Level
  },
  props: {
    selectedItemId: {
        type: Number,
        required: true,
    },
  },
  data: () => ({
    isLoading: true,
    selectedItem: null,
    selectedTab: 0,
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    loadData () {
      ClientsService.details(this.selectedItemId)
        .then(({ data }) => {
          this.selectedItem = data;
        })
        .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }); this.$emit('onSubmit'); })
        .finally(() => setTimeout(() => (this.isLoading = false), 300));
    },
  },
}
</script>
